module.exports = __webpack_public_path__ + "static/media/Responsabilidad_social.81753af3.webp";